import { zergApi } from "@/service/zerg";

class EmailGroupsService {
    BASE_URL = "setting/general/group";

    async listEventRecipients(params) {
        const url = `${this.BASE_URL}/list-event-recipients`;
        try {
            const data = await zergApi.post(url, params);
            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async addUserIntoEvent(params) {
        const url = `${this.BASE_URL}/add-user-into-event`;
        try {
            const data = await zergApi.post(url, params);
            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async searchRecipientGroupsByText(params) {
        const url = `${this.BASE_URL}/search-recipient-groups-by-text`;
        try {
            const data = await zergApi.post(url, params);
            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async addRecipientGroupIntoEvent(params) {
        const url = `${this.BASE_URL}/add-recipient-group-into-event`;
        try {
            const data = await zergApi.post(url, params);
            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async removeUserFromEvent(params) {
        const url = `${this.BASE_URL}/remove-user-from-event`;
        try {
            const data = await zergApi.post(url, params);
            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async removeRecipientGroupFromEvent(params) {
        const url = `${this.BASE_URL}/remove-recipient-group-from-event`;
        try {
            const data = await zergApi.post(url, params);
            return data;
        } catch (error) {
            console.error(error);
        }
    }
}

export default new EmailGroupsService();